import { langIf } from './types';
const ja: langIf = {
  title: 'ポケモンSV 時計アプリ',
  description:
    'ポケットモンスター スカーレット・バイオレット（ポケモンSV）のゲーム内時間を知ることができる時計アプリです。',
  createFirstClock: '最初の時計を作る',
  createInGameClock: 'ゲーム内時計の作成',
  openMapView: 'マップ画面を開いてゲーム内の時間帯を確認してください。',
  inGameTimeisDifferentForEachSave:
    'ゲーム内時間はセーブデータごとに異なります。',
  selectCurrentInGameTime: '現在のゲーム内の時間帯を選択してください。',
  pressSubmitWhenTimeChanged:
    'ゲーム内の時間帯が次に変わったタイミングでボタンを押してください：',
  morning: '朝',
  day: '昼',
  evening: '夕方',
  night: '夜',
  back: '戻る',
  close: '閉じる',
  next: '次へ',
  privacyPolicy: 'プライバシーポリシー',
  beforeUsing: '利用前に以下のご確認をお願いします。',
};
export default ja;
